import * as React from 'react';

const IconPin = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M12 1.35a7 7 0 0 1 7 7c0 3.31-5.133 11.556-6.607 13.86a.467.467 0 0 1-.786 0C10.133 19.907 5 11.66 5 8.35a7 7 0 0 1 7-7z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M12 11.15a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconPin;
